import { api } from './client';
import type { AuditPage } from './types';

export interface AuditFilters {
  actor?: string;
  resource_type?: string;
  from?: string;
  to?: string;
  cursor?: string;
  limit?: number;
}

export function listAudit(filters: AuditFilters): Promise<AuditPage> {
  return api.get<AuditPage>('/api/v1/audit', filters as Record<string, string | number | boolean | undefined>);
}
